import { HTMLAttributes } from 'react'

import { ThemeProps } from '@/contexts/theme/Theme'

import { cn } from '@/lib/utils'

export type LogoProps = HTMLAttributes<HTMLSpanElement> &
  Partial<{
    theme: ThemeProps['theme']
  }>

const Logo = ({ theme = 'dark', className, ...props }: LogoProps) => {
  return (
    <span className={className} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 79.625 13.237"
        width={79.625}
        height={13.237}
        className={cn('transition-all duration-300 ease-out-cubic', [
          {
            'fill-white': theme === 'dark',
            'fill-black': theme === 'light'
          }
        ])}
      >
        <path d="M11.1.813v4.272H2.462V.813H0v11.658h2.462V7.362H11.1v5.109h2.486V.813Z" />
        <path d="M17.531.812h11.635v2.276h-9.1v2.16h7.64v2.3h-7.667v2.646h9.127v2.276H17.531Z" />
        <path d="M32.532 0v12.47h2.438V4.876l11.079 8.36V.812h-2.464V8.36Z" />
        <path d="M64.672 7.201c0 3.831-3.252 5.689-7.2 5.689-4.528 0-8.173-2.81-8.173-6.245 0-3.461 3.645-6.271 8.173-6.271A9.856 9.856 0 0 1 63 2.092v3.042a6.945 6.945 0 0 0-5.528-2.507c-3.135 0-5.572 1.787-5.572 4.018s2.437 3.993 5.572 3.993c1.928 0 4.111-.464 4.552-1.9H58.56V6.501h6.109Z" />
        <path d="M67.989.813v11.658h11.635v-2.276h-9.126V7.547h7.664v-2.3h-7.641V3.089h9.1V.813Z" />
      </svg>
    </span>
  )
}

export default Logo
